module.exports = __webpack_public_path__ + "img/mb_banner1.2557d6cb.jpg";